import { render, staticRenderFns } from "./SettingsVatProducts.vue?vue&type=template&id=53312c81&"
import script from "./SettingsVatProducts.vue?vue&type=script&lang=js&"
export * from "./SettingsVatProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports